export default (
  state = {
    currentGSheetTab: {},
    gSheetRevvTables: {},
    reUpdateWorkBooksOption: false,
  },
  action,
) => {
  switch (action.type) {
    case "UPDATE_GSHEET_TABLES": {
      // eslint-disable-next-line no-unused-vars
      const { sectionID, tableSection } = action.payload;
      const newTables = { ...state.gSheetRevvTables };
      newTables[sectionID] = tableSection;
      return {
        ...state,
        gSheetRevvTables: newTables,
      };
    }
    case "REMOVE_GOOGLESHEET_DATA": {
      const newTables = { ...state.gSheetRevvTables };
      if (action.payload) delete newTables[action.payload];
      return {
        ...state,
        gSheetRevvTables: newTables,
      };
    }
    case "CURRENT_G_SHEET_TAB": {
      return {
        ...state,
        currentGSheetTab: action.payload,
      };
    }
    case "REUPDATE_WORKSHEET_OPTIONS": {
      return {
        ...state,
        reUpdateWorkBooksOption: action.payload,
      };
    }
    case "MAKE_EMPTY_RANGE": {
      return {
        ...state,
        currentGSheetTab: action.payload,
      };
    }
    case "UPDATE_FIRST_ROW_AS_HEADER_KEY": {
      return {
        ...state,
        currentGSheetTab: action.payload,
      };
    }
    default:
      return state;
  }
};
